/* unplugin-vue-components disabled */import { render } from "./NavbarTabs.vue?vue&type=template&id=2d5da206&ts=true"
import script from "./NavbarTabs.vue?vue&type=script&lang=ts"
export * from "./NavbarTabs.vue?vue&type=script&lang=ts"

import "./NavbarTabs.vue?vue&type=style&index=0&id=2d5da206&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__